import { useState, useEffect } from 'react';
import { WEEKDAYS, type Weekday } from '@/features/plants/schemas/schedule-plant.schema.ts';

function getCurrentMinuteOfDay(): number {
  const now = new Date();
  return now.getHours() * 60 + now.getMinutes();
}

export function getTodayWeekday(): Weekday {
  const jsDay = new Date().getDay();
  const index = jsDay === 0 ? 6 : jsDay - 1;
  return WEEKDAYS[index];
}

export function useCurrentTimePosition(): number {
  const [minuteOfDay, setMinuteOfDay] = useState(() => getCurrentMinuteOfDay());

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval> | null = null;

    const update = () => {
      setMinuteOfDay(getCurrentMinuteOfDay());
    };

    const now = new Date();
    const msUntilNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    const timeoutId = setTimeout(() => {
      update();
      intervalId = setInterval(update, 60_000);
    }, msUntilNextMinute);

    return () => {
      clearTimeout(timeoutId);
      if (intervalId !== null) {
        clearInterval(intervalId);
      }
    };
  }, []);

  return minuteOfDay;
}
